import React, { useEffect } from "react";
import { connect } from "react-redux";
import CardDetail from "../../../components/CardDetail/CardDetail";
import CardBlockRelated from "../../../components/CardBlockRelated/CardBlockRelated";
import ProductInfo from "../../../components/ProductInfo/ProductInfo";
import Comment from "../../../components/Comment/Comment";
import { HOST_URL } from "../../../utils/misc.js";
import {
    getProductDetail,
    getProductImageDetail,
    getProductRelated,
    clearProductDetail
} from "../../../redux/actions/products_actions";
import NProgress from 'nprogress';

const ProductDetail = (props) => {
  // Get CategoryName
  // const category = (props.match.params.category).toString();
  
  useEffect(() => {
    NProgress.start();
    // Scroll To Top
    window.scrollTo({top: 0, left: 0})

    const id = props.match.params.id;
    // console.log(id)
    const keyword = ""
    props.dispatch(getProductDetail(id, keyword)).then(res => {
        if(res.payload.product != undefined) {
          props.dispatch(getProductRelated(res.payload.product.productId, res.payload.product.categoryName))
        }
        else {
          props.history.push('/')
        }
    })
    props.dispatch(getProductImageDetail(id, keyword)).then(res => {
      if(res.payload === undefined) {
          props.history.push('/')
      }
    })
  }, [window.location.pathname]);

  // props.<combineReducer>.<reducer>.<action>.<property>
  // console.log(props.products.productDetail)

  if(props.products.productDetail && props.products.productDetail.product && props.products.productImageDetail && props.products.productImageDetail.productImage && props.products.productRelated && props.products.productRelated.products) {
    NProgress.done();
    return (
      <>
        <div className="container-fluid p-0">
          <div style={{backgroundColor:`${props.templates.templates.templateProperties.background_product_detail}`}}>
            <div className="justify-content-center" style={{display:'flex'}}>
              <CardDetail product = {props.products.productDetail.product} productImageDetail={props.products.productImageDetail.productImage} />
            </div>
          </div>          
          <h4 className="text-center"><b style={{ fontWeight: "bold" }}>Chi Tiết Sản Phẩm</b></h4>
          <ProductInfo product = {props.products.productDetail.product} />              
          <div className="productRelatedSpacing">
            <h4 className="text-center"><b style={{ fontWeight: "bold" }}>Sản Phẩm Liên Quan</b></h4>
            <CardBlockRelated
              list={props.products.productRelated.products}
              type="sofa"
              title="All Sofa Products" />
          </div>
          <div className="container" style={{ background:`${props.templates.templates.templateProperties.background_comment}`, justifyContent:"center", alignItems:"center", borderRadius:10, padding:20, margin:'2% auto' }}>
            <Comment />
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="text-center loading">
            <img src={HOST_URL + props.templates.templates.templateProperties.image_loading} style={{width: 150}} />    
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    products: state.products,
    templates: state.templates,
  };
};
export default connect(mapStateToProps)(ProductDetail);
